export default __webpack_public_path__ + "static/media/khongvong.6594c293.png";